/* YUCOLLECT FILE permissions */
// ** MANAGE_DISCOVERY permissions **
export const ALLOCATOR_VIEW_DISCOVER_AGENCY = 'allocator_view_discover_agency';
export const ALLOCATOR_VIEW_MY_AGENCIES = 'allocator_view_my_agencies';
export const ALLOCATOR_VIEW_INVITED_AGENCIES =
  'allocator_view_invited_agencies';
export const ALLOCATOR_SEND_INTEREST_AGENCY = 'allocator_send_interest_agency';
export const ALLOCATOR_VIEW_AGENCY_PROFILE = 'allocator_view_agency_profile';
export const ALLOCATOR_ALLOCATE_TO_AGENCIES = 'allocator_allocate_to_agencies';
export const AGENCY_VIEW_ALLOCATOR_REQUEST = 'agency_view_allocator_request';
export const AGENCY_UPDATE_ALLOCATOR_REQUEST =
  'agency_update_allocator_request';

// ** MANAGE_ALLOCATIONS permissions **
export const VIEW_ALLOCATIONS = 'view_allocations';
export const UPLOAD_ALLOCATION = 'upload_allocation';
export const DOWNLOAD_ALLOCATION = 'download_allocation';
export const VIEW_ALLOCATION_DASHBOARD = 'view_allocation_dashboard';
export const DOWNLOAD_ALLOCATION_REPORT = 'download_allocation_report';

// ** CHANNEL_PLANNER permissions **
export const VIEW_CHANNEL_PLANNER = 'view_channel_planner';
export const VIEW_ADVANCE_PLANNER = 'view_advance_planner';
export const ASSIGN_CHANNEL_ALLOCATION = 'assign_channel_allocation';
export const MERGE_HISTORY = 'merge_history';
export const DOWNLOAD_HISTORY = 'download_history';

// ** DIGITAL_PLANNER permissions **
export const VIEW_DIGITAL_SUMMARY = 'view_digital_summary';
export const VIEW_DIGITAL_PLANNER = 'view_digital_planner';
export const START_DIGITAL_CAMPAIGN = 'start_digital_campaign';
export const STOP_DIGITAL_CAMPAIGN = 'stop_digital_campaign';
export const MODIFY_DIGITAL_CAMPAIGN = 'modify_digital_campaign';
export const VIEW_DIGITAL_DASHBOARD = 'view_digital_dashboard';

// ** CALL_PLANNER permissions **
export const VIEW_CALL_SUMMARY_SUPERVISOR = 'view_call_summary_supervisor';
export const VIEW_CC_BORROWER_DETAIL = 'view_cc_borrower_detail';
export const START_MANUAL_DIAL = 'start_manual_dial';
export const VIEW_CC_AGENT_DASHBOARD = 'view_cc_agent_dashboard';
export const ASSIGN_CALL_AGENTS = 'assign_call_agents';
export const VIEW_CALL_CONFIG = 'view_call_config';
export const UPDATE_CALL_CONFIG = 'update_call_config';

// ** FIELD_PLANNER permissions **
export const VIEW_FIELD_SUMMARY_SUPERVISOR = 'view_field_summary_supervisor';
export const VIEW_FIELD_BORROWER_DETAIL = 'view_field_borrower_detail';
export const VIEW_FIELD_AGENT_DASHBOARD = 'view_field_agent_dashboard';
export const ASSIGN_FIELD_AGENTS = 'assign_field_agents';
export const VIEW_FIELD_CONFIG = 'view_field_config';
export const UPDATE_FIELD_CONFIG = 'update_field_config';

// ** COMPLIANCE_PLUS permissions **
export const VIEW_COMPLIANCE_PLUS = 'view_compliance_plus';
export const VIEW_COMPLIANCE_TASK = 'view_compliance_task';
export const CREATE_COMPLIANCE_TASK = 'create_compliance_task';

// ** CONFIGURATIONS permissions **
export const VIEW_PREFERENCES = 'view_preferences';
export const UPDATE_PREFERENCES = 'update_preferences';
export const VIEW_ORG_PROFILE = 'view_org_profile';
export const UPDATE_ORG_PROFILE = 'update_org_profile';

// ** COMPLIANCE permissions **
export const VIEW_COMPLIANCE = 'view_compliance';
export const EDIT_COMPLIANCE = 'edit_compliance';
export const VIEW_ALLOCATOR_COMPLIANCE = 'view_allocator_compliance';

// ** USER_MANAGEMENT permissions **
export const VIEW_DESIGNATIONS = 'view_designations';
export const EDIT_DESIGNATIONS = 'edit_designations';
export const VIEW_HIERARCHY_SETUP = 'view_hierarchy_setup';
export const EDIT_HIERARCHY_SETUP = 'edit_hierarchy_setup';

// ** CONTENT permissions **
export const VIEW_CONTENT = 'view_content';
export const EDIT_CONTENT = 'edit_content';
export const CREATE_CONTENT = 'create_content';
export const PUBLISH_CONTENT = 'publish_content';
export const DELETE_CONTENT = 'delete_content';
export const TEST_CONTENT = 'test_content';

export const VIEW_PLANNER = 'view_planner';
export const VIEW_CALL_CENTER = 'view_call_center';
// export const VIEW_DIGITAL = 'view_digital';
export const VIEW_FIELD = 'view_field_borrower_detail';
export const VIEW_FIELD_SUPERVISOR = 'view_field_summary_supervisor';
export const VIEW_REPORTS = 'view_reports';
export const VIEW_AGENT_SOLUTION = 'view_agent_solution';
export const ADD_AGENTS = 'add_agents';
export const VIEW_SUPPORT = 'view_support';
export const VIEW_AUTO_COLLECT = 'view_auto_collect';
export const VIEW_TRACE = 'view_trace';
export const VIEW_SCORE = 'view_score';
export const VIEW_WORKING_CAPITOL = 'view_working_capitol';
export const VIEW_ALL_AGENCY = 'view_all_agency';
export const VIEW_PRICING = 'view_pricing';
export const APPROVE_AGENCY_DOCUMENT = 'approve_agency_document';
export const REJECT_AGENCY_DOCUMENT = 'reject_agency_document';
export const VIEW_TRAINING = 'view_training';
export const VIEW_AGENT_LIST = 'view_agent_list';
export const VIEW_AGENT_GROUPS = 'view_agent_groups';
export const VIEW_CALL_CAMPAIGNS = 'view_campaigns';
export const VIEW_INCENTIVE = 'view_incentive';
